<template>
  <div class="insights-actions-loader">
    <div class="date-picker-loader-wrap">
      <v-skeleton-loader
        v-for="i in numOfLoaders"
        :key="i"
        type="button"
        class="date-picker-loader"
        width="90px"
        height="40px"
      />
    </div>
    <span class="pr-4" />
  </div>
</template>

<script setup>
defineProps({
  numOfLoaders: {
    type: Number,
    default: 3,
  },
});
</script>

<style lang="less" scoped>
.v-skeleton-loader {
  background: transparent;
  border-radius: 0px;

  :deep(.v-skeleton-loader__button) {
    margin: 0;
    border-radius: 0px;
    max-width: 90px;
    height: 40px;
  }
}

.insights-actions-loader {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.date-picker-loader-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;

  .date-picker-loader:not(:last-child) {
    border-right: 1px solid @bg-canvas;
  }
}
</style>
